import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import {
	fnCallable,
	GetOutstandingUndertakingsRequest,
	OutstandingUndertakingsResponse,
} from '@fnModels/undertakings';
import LogRocket from 'logrocket';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class UndertakingsFunctions {
	constructor(private fns: AngularFireFunctions) {}

	getOutstandingUndertakings = (
		filterProperty: string,
		filterValue: string,
		businessId: string,
	): Observable<OutstandingUndertakingsResponse[]> => {
		const callable = this.fns.httpsCallable(
			fnCallable.getOutstandingUndertakings,
		);

		const request: GetOutstandingUndertakingsRequest = {
			filterProperty,
			filterValue,
			businessId,
		};

		return callable(request).pipe(
			map((response) => {
				if (response.httpErrorCode) {
					LogRocket.captureMessage(
						'UndertakingsFunctions:getOutstandingUndertakings failed',
						{
							extra: response.httpErrorCode,
						},
					);
					return throwError(response);
				} else return response;
			}),
		);
	};
}
